<template>
  <b-form>
    <b-form-row>
      <b-form-group class="col-sm-12 col-md-6">
        <label for="id_via_ingreso">Vía de ingreso <span style="color: red">(*)</span></label>
        <el-select v-model="selectedToxicidad.id_via_ingreso"
                   name="id_via_ingreso"
                   placeholder=" "
                   size="small"
                   data-vv-as=" "
                   v-validate="{
                     rules: {
                       required: true
                     }
                   }"
        >
          <el-option v-for="item in vias_ingreso"
                     :key="item.id"
                     :label="item.lista"
                     :value="item.id"
          />
        </el-select>
        <span class="text-danger span-error small"
              v-text="errors.first('error.id_via_ingreso')"
        />
      </b-form-group>
      <b-form-group class="col-sm-12 col-md-6">
        <label for="componente">Componente <span style="color: red">(*)</span></label>
        <b-form-input
          type="text"
          name="componente"
          v-model="selectedToxicidad.componente"
          required
        >
        </b-form-input>
      </b-form-group>
    </b-form-row>
    <b-form-row>
      <b-form-group class="col-sm-12 col-md-6">
        <label for="id_animal">
          {{(tipo_toxicidad === 'ecotoxicidad') ? 'Especie' : 'Animal'}}
          <span style="color: red">(*)</span>
        </label>
        <el-select v-model="selectedToxicidad.id_animal"
                   name="id_animal"
                   placeholder=" "
                   size="small"
                   data-vv-as=" "
                   v-validate="{
                     rules: {
                       required: true
                     }
                   }"
        >
          <el-option v-for="item in animales"
                     :key="item.id"
                     :label="item.lista"
                     :value="item.id"
          />
        </el-select>
      </b-form-group>
      <b-form-group class="col-sm-12 col-md-6">
        <label for="id_marcador">Marcador <span style="color: red">(*)</span></label>
        <el-select v-model="selectedToxicidad.id_marcador"
                   name="id_marcador"
                   placeholder=" "
                   size="small"
                   data-vv-as=" "
                   v-validate="{
                     rules: {
                       required: true
                     }
                   }"
        >
          <el-option v-for="item in marcadores"
                     :key="item.id"
                     :label="item.lista"
                     :value="item.id"
          />
        </el-select>
      </b-form-group>
    </b-form-row>
    <b-form-row>
      <!-- Presion de Vapor -->
      <BInputUm
        bv_class="col-md-12"
        parentState="selectedToxicidad"
        :input_text="'Valor ' + marcador"
        v_model_range="valor_rango"
        v_model="valor"
        :required="true"
        :show_um_label="true"
        v_model_up_to="valor_hasta"
        v_model_um="id_um_valor"
        :um_type="marcador"
        :values="selectedToxicidad"
      />
    </b-form-row>
  </b-form>
</template>

<script>
import {mapActions, mapState} from "vuex";
import BInputUm from "@/views/fds/componentes/BInputUm.vue";

export default {
  name: "ModalFormToxicidad",
  components: {
    BInputUm
  },
  data: function () {
    return {
      marcador: 'DL50',
    };
  },
  async created() {
    await this.getAnimales();
    await this.getViasIngreso();
    await this.getMarcadores();
  },
  watch: {
    'selectedToxicidad.id_marcador'(val) {
      if (val !== '') {
        let marcadorObj = this.marcadores.filter((marcador) => marcador.id === val);
        if (marcadorObj.length !== 0) {
          this.marcador = marcadorObj[0].lista;
        }
      }
    }
  },
  methods: {
    ...mapActions('fds_productos',[
      'getAnimales',
      'getViasIngreso',
      'getMarcadores',
    ]),
  },
  computed: {
    ...mapState('fds_productos',[
      'selectedToxicidad',
      'tipo_toxicidad',
      'vias_ingreso',
      'animales',
      'marcadores',
    ]),
  }
}
</script>

<style scoped>

</style>
